export const bypassLazySizes = (element: HTMLElement): boolean => {
    const dataSrc = element.getAttribute('data-src');
    if (!dataSrc) {
        return false;
    }
    element.setAttribute('src', dataSrc);
    element.classList.remove("lazyload", "lazyloading");
    element.classList.add("lazyloaded");
    return true;
};
